export const RadialScoreChart = ({
  score,
  percentScore,
}: {
  score: number;
  percentScore: number;
}) => {
  const radius = 80;
  const circumference = Math.PI * radius;
  const offset = circumference - (percentScore / 100) * circumference;

  return (
    <div className="relative flex items-center justify-center w-[200px] h-[110px] overflow-visible">
      <svg className="absolute bottom-0 w-full h-[160px]" viewBox="0 0 200 100">
        <defs>
          <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#f1361d" />
            <stop offset="33%" stopColor="#f59e0b" />
            <stop offset="66%" stopColor="#ffc609" />
            <stop offset="100%" stopColor="#3db51d" />
          </linearGradient>
        </defs>
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="#f3f3f4"
          strokeWidth="12"
          strokeLinecap="round"
        />
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="url(#scoreGradient)"
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="transition-all duration-1000 ease-out"
        />
      </svg>
      <div className="absolute bottom-2 flex flex-col items-center">
        <span className="text-[30px] font-bold text-[#0c0e21] leading-none font-inter">
          {score}
        </span>
      </div>
    </div>
  );
};
